import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Success from "./Success";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TermsAndConditions from "./terms";

const root = ReactDOM.createRoot(document.getElementById("hyper-root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/success" element={<Success />} />
        <Route path="/" element={<App />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
